import { darken } from "@mui/material";

const MuiCardHeader = {
  styleOverrides: {
    root: ({theme} : any) => ({
      alignItems: 'center',
       padding: '0px 0px 24px 0px',
      '& .MuiCardHeader-title':{
       fontSize: '1rem !important',
       fontStyle: 'normal',
       fontWeight: '600',
       lineHeight: '22px',
       color: theme.palette.text.primary,
      },

      '& .MuiCardHeader-avatar' :{
        position: 'absolute',
        marginLeft: '260px',
      },

    }),
  },
};

export default MuiCardHeader;
